
import Vue from "vue";
import {ProductModelFactory} from "../../model/product/ProductModelFactory";
import NavigationItem from "../../components/navigation/NavigationItem.vue";

export default Vue.extend({
  components: {NavigationItem},
  props: {
    parent: {
      type: Object,
      default: () => ProductModelFactory.createEmptyContentNode(),
    },
    activeNode: {
      type: Object,
      default: () => ProductModelFactory.createEmptyContentNode(),
    },
    maxLevel: {
      type: Number,
      default: 0,
    },
  },
});
